/*eslint @typescript-eslint/no-unused-vars: 'off'*/
import { Check, CheckBoxOutlineBlankOutlined, Create, Delete } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { FC, useCallback, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Outlet, useFetcher, useNavigate, useOutletContext, useParams, useRouteLoaderData } from 'react-router-dom';
import { normalizePhone, validatePhoneNumber } from './components/AwesomePhoneField';
import { convertData } from './components/PatientRecipientForm';
import { ProfileData, PatientRecipientFormData, addRecipient, updateRecipient, deleteRecipient } from './profiles';
import { commTypes, splitArray, StyledTableCell, StyledTableRow } from './ProfIndex';
import { AssetInterface } from './types';
// import { validate as validateEmail } from 'isemail';
import { IconButton, Toolbar } from '@mui/material';
import { ProfOutletContext } from './Prof';


export const validateEmail = ( email: string ): boolean => true;  // TODO HERE

export const ProfRecipientOutlet: FC = () => {
  const context = useOutletContext<ProfOutletContext>();
  return (
    <div id='recipient'>
      <Outlet {...{ context }} />
    </div>
  );
}

export const ProfRecipientShow: FC = () => {
  const { recipientId } = useParams();
  // const {
  //   profileId, recipient, recipients = [], organization, assets = [], countryCode,
  //   // isXSmall = false, isSmall = false, isMedium = true,
  //   // notify, setNotify,
  // } = useOutletContext<ProfOutletContext>();
  const data = useRouteLoaderData( 'prof' ) as ProfileData;
  const { recipients } = data || {};

  const navigate = useNavigate();
  const recipient = useMemo<PatientRecipientFormData | undefined>( () => {
    if( !recipients ) return;
    const recipient = recipients.find( r => r.id == recipientId );
    if( !recipient ) return;
    return convertData( recipient );
  }, [ recipientId, recipients ] );

  // const onDeleteRecipient = useCallback( async ( id: string ) => {
  //   await deleteRecipient( profileId, id );
  //   setIsLoaded( false );
  // }, [ profileId ] );

  if( !recipient ) return null;

  return (
    <Box >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          color='error'
          startIcon={<Delete />}
          onClick={() => { alert( 'delete' ) }}
        >
          Delete
        </Button>
        <Button
          startIcon={<Create />}
          sx={{ marginLeft: '2em' }}
          onClick={() => { navigate( 'edit' ) }}
        >
          Edit
        </Button>
      </Toolbar>
      <Grid container direction='column' spacing={1} >

        <Grid item>
          <Typography
            variant='caption'
          // sx={{color: theme.palette.grey[ 700 ]}}
          >
            Name
          </Typography>
          <Typography>
            {recipient.fullName}
          </Typography>
        </Grid>

        <Grid item>
          <Typography variant='caption'>
            Email
          </Typography>
          <Typography>
            {recipient.email}
          </Typography>
        </Grid>

        <Grid item>
          <Typography variant='caption'>
            Phone
          </Typography>

          <Typography>
            {recipient.phone}
          </Typography>
        </Grid>

        <Grid item>

          <Typography
            variant='caption'
            paragraph
          >
            Communication Types
          </Typography>

          {splitArray( commTypes, 3 ).map( commTypes => (

            <TableContainer sx={{ width: 'fit-content', display: 'inline-block', verticalAlign: 'top' }}>
              <Table size='small' padding='none' aria-label='selected communications table'
              >
                <TableBody>
                  {commTypes.map( ( row, idx ) => {
                    return (
                      <StyledTableRow
                        key={`row${ idx }`}
                        hover={true}
                      >
                        <StyledTableCell scope='row' >
                          {recipient[ row.field ]
                            ? <CheckBoxOutlineBlankOutlined sx={{ verticalAlign: 'text-bottom' }} />
                            : <Check sx={{ verticalAlign: 'text-bottom' }} />
                          }
                          <Typography
                            component='span'
                            sx={{
                              marginLeft: 1
                            }}
                          >
                            {row.label}
                          </Typography>


                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  } )}
                </TableBody>
              </Table>
            </TableContainer>
          ) )}
        </Grid>
      </Grid>
    </Box>
  )
}


export const ProfRecipientAdd: FC = () => {
  const { profileId } = useParams();
  const navigate = useNavigate();
  const { setNotify } = useOutletContext<ProfOutletContext>();
  const data = useRouteLoaderData( 'prof' ) as ProfileData;
  const { recipients } = data || {};

  const onAddRecipient = useCallback( async ( data: PatientRecipientFormData ) => {
    console.log( JSON.stringify( data ) );
    await addRecipient( profileId, data );
    navigate( '..' );
    setNotify( 'New recipient saved' );
  }, [ profileId ] );

  return (
    <ProfRecipientForm
      data={{}}
      onSubmit={onAddRecipient}
    />
  );
}

export const ProfRecipientEdit: FC = () => {
  const { profileId, recipientId } = useParams();
  const navigate = useNavigate();
  const {
    // isXSmall = false, isSmall = false, isMedium = true,
    setNotify,
  } = useOutletContext<ProfOutletContext>();
  const data = useRouteLoaderData( 'prof' ) as ProfileData;
  const { recipients } = data || {};

  const recipient = useMemo<PatientRecipientFormData | undefined>( () => {
    if( !recipients ) return;
    const recipient = recipients.find( r => r.id == recipientId );
    if( !recipient ) return;
    return convertData( recipient );
  }, [ recipientId, recipients ] );

  const onEditRecipient = useCallback( async ( data: PatientRecipientFormData ) => {
    console.log( JSON.stringify( data ) );
    await updateRecipient( profileId, recipientId, data );
    navigate( '..' );
    setNotify( 'Update saved' );
  }, [ profileId ] );

  if( !recipient ) return null;

  return (
    <ProfRecipientForm
      data={recipient}
      onSubmit={onEditRecipient}
    /> // { ...rest } />
  );
}

export interface ProfRecipientFormProps {
  data: Partial<PatientRecipientFormData>;
  countryCode?: string;
  onSubmit: ( data: PatientRecipientFormData ) => void; // TODO
  onClose?: () => void;
}

export const ProfRecipientForm: FC<ProfRecipientFormProps> = ( props ) => {
  const { countryCode = 'US', onSubmit, data: defaultValues } = props;
  const { control, getValues, handleSubmit, formState: { errors, isDirty, isValidating, isValid, isSubmitted, isSubmitting } } = useForm<PatientRecipientFormData>( { defaultValues } );
  const navigate = useNavigate();

  const isAdd = useMemo<boolean>( () => {
    return defaultValues.fullName === '';
  }, [] );

  return (
    <Box>
      <Typography>
        Edit {defaultValues.fullName}
      </Typography>

      <form>


        <Controller
          name='fullName'
          control={control}
          rules={{
            required: 'Name is required',
            // minLength: {
            //   value: 5,
            //   message: 'At least 5 chars'
            // }
          }}
          render={( { field } ) => (
            <TextField
              {...field}
              inputRef={field.ref}
              autoFocus
              required
              margin='dense'
              label='Name'
              fullWidth
              variant='filled'
              error={!!errors?.fullName?.message}
              helperText={errors?.fullName?.message}
            />
          )}
        />

        <Controller
          name='email'
          control={control}
          rules={{
            validate: {
              required: () => !!getValues( 'email' ) || !!getValues( 'phone' ) || 'Either email or phone is required',
              valid: ( email ) => !email || validateEmail( email ) || 'Must be an email',
            }
          }}
          render={( { field } ) => (
            <TextField
              {...field}
              inputRef={field.ref}
              onChange={( e ) => field.onChange( e.target.value.toLowerCase() )}
              margin='dense'
              label='Email'
              type='email'
              fullWidth
              variant='filled'
              error={!!errors?.email?.message}
              helperText={errors?.email?.message}
            />
          )}
        />

        <Controller
          name='phone'
          control={control}
          rules={{
            validate: {
              required: () => !!getValues( 'email' ) || !!getValues( 'phone' ) || 'Either email or phone is required',
              valid: ( phone ) => !phone || validatePhoneNumber( countryCode )( phone ) || 'Must be a phone number',
            },
          }}
          render={( { field } ) => {
            // field.onChange( normalizePhone( countryCode ) )
            return (
              <TextField
                {...field}
                inputRef={field.ref}
                onChange={( e ) => field.onChange( normalizePhone( countryCode )( e.target.value ) )}
                margin='dense'
                label='Phone'
                fullWidth
                variant='filled'
                error={!!errors?.phone?.message}
                helperText={errors?.phone?.message}
              />
            );
          }}
        />

        <section>

          <FormLabel component='legend' sx={{ marginTop: 4 }}>
            Communication Types
          </FormLabel>

          {splitArray( commTypes, 3 ).map( ( commTypes, idx ) => (

            <TableContainer
              key={idx}
              sx={{ width: 'fit-content', display: 'inline-block', verticalAlign: 'top' }}
            >
              <Table size='small' padding='none' aria-label='selected communications table'
              >
                <TableBody>
                  {commTypes.map( ( row, idx ) => {
                    return (
                      <StyledTableRow
                        key={`row${ idx }`}
                        hover={true}
                      >
                        <StyledTableCell scope='row' >
                          <Controller
                            key={`row${ idx }`}
                            name={row.field}
                            control={control}
                            render={( { field } ) => (
                              <FormControlLabel
                                label={row.label}
                                control={
                                  <Checkbox
                                    onChange={( e ) => field.onChange( !e.target.checked )}
                                    checked={!field.value}
                                  />
                                }
                              />
                            )}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  } )}
                </TableBody>
              </Table>
            </TableContainer>
          ) )}
        </section>

      </form>
      <Toolbar>
        <Button
          onClick={() => { navigate( '..' ) }}
          disabled={isSubmitting || ( isSubmitted && isValid )}
        >
          Cancel
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <Button variant='contained'
          disabled={!isDirty || isValidating || isSubmitting || isSubmitted}
          onClick={handleSubmit( onSubmit, ( v ) => { console.log( errors, v ) } ) /*onSubmit( getValues() ) */}
        >
          {isAdd ? 'Add' : 'Save'}
        </Button>
      </Toolbar>
    </Box>
  );
}
